import lodash from "lodash";

export default defineNuxtPlugin((nuxtApp) => {
  return {
    provide: {
      lodash: lodash,
    },
  };
});
